import React, { useEffect, useRef, useState } from 'react'
import Main from '../../Main'
import { Col, Row } from 'react-bootstrap'
import '../../../assets/css/dashboard.scss'
import totalCustomer from '../../../assets/images/Dashboard/total-customer-img.svg'
import activeInactive from '../../../assets/images/Dashboard/total-active-inactive-img.svg'
import customerUnderValidity from '../../../assets/images/Dashboard/total-customer-under-validity.svg'
import customerLicenseExperation from '../../../assets/images/Dashboard/customer-licence-expiration.svg'
import Download from '../../MainSection/Download/Download'
import BarChart from '../../Graphs/BarChart'
import RelationshipTypeChart from '../../Graphs/RelationshipTypeChart'
import FunnelChart from '../../Graphs/FunnelChart'
import LicenceSpliteUpChart from '../../Graphs/LicenceSpliteUpChart'
import CustomerStatusChart from '../../Graphs/CustomerStatusChart'
import AssignedModules from '../../Graphs/AssignedModules'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { loadCustomerDashboardCardData } from '../../../redux/action'
import Skeleton from 'react-loading-skeleton';
import html2canvas from 'html2canvas';
import * as XLSX from 'xlsx';

function DashBoard() {
    let dispatch = useDispatch();

    const { getCustomerDashboardCardData } = useSelector((state) => state.data);

    const [loading, setLoading] = useState(true);

    useEffect(() => {
        dispatch(loadCustomerDashboardCardData(null, setLoading));
    }, [])

    const labels = ['Active', 'Inactive', 'New'];
    const colors = [
        'rgba(58, 201, 119, 1)', // Active
        'rgba(255, 94, 94, 1)',  // Inactive
        'rgba(255, 159, 0, 1)'  // New
    ];
    const data = [25, 20, 13];

    const Rlabels = ['Headquarter', 'Business Unit', 'Branch Office', 'Storage Location'];
    const Rcolors = [
        'rgba(58, 201, 119, 1)', // Headquarter
        'rgba(255, 94, 94, 1)',  // Business Unit
        'rgba(255, 159, 0, 1)',  // Branch Office
        'rgba(52, 58, 64, 1)',  // Storage Location
    ];
    const Rdata = [25, 20, 13, 30];

    const funnelColors = ['rgba(0, 133, 163, 1)', 'rgba(3, 170, 207, 1)', 'rgba(6, 201, 244, 1)'];
    const funnelLabels = ['LC Available', 'LC Used', 'LC Provider'];
    const funnelData = [
        { value: 200 },
        { value: 150 },
        { value: 100 },
    ];
    const navigate = useNavigate();
    const handleDashboardLibraryClick = () => {
        navigate('/dashboard-library')
    }
    const handleBack = () => {
        navigate(-1);
    };

    const handleNavigation = () => {
        navigate('/customermanagement')
    }

    // Default state for the number of days (between 0 and 30)
    const [daysRemaining, setDaysRemaining] = useState(30);

    // Handler for changing the range slider value
    const handleSliderChange = (event) => {
        const newDays = parseInt(event.target.value, 10); // Update daysRemaining with slider value
        setDaysRemaining(newDays);

        // Pass the updated LicenseExpiryDays value to the API (only for the License Expiration card)
        dispatch(loadCustomerDashboardCardData(newDays, setLoading));  // Passing the new daysRemaining value to the API call
    };

    const barChartRef = useRef(null);
    const licenceSpliteUpRef = useRef(null);
    const NoofLicenceFunnelRef = useRef(null);
    const customerStatusChartRef = useRef(null);
    const relationShipTypeChartRef = useRef(null);

    const handleDownloadExcel = () => {
        barChartRef.current.handleDownloadExcel();
        licenceSpliteUpRef.current.handleDownloadExcel();
        NoofLicenceFunnelRef.current.handleDownloadExcel();
        customerStatusChartRef.current.handleDownloadExcel();
        relationShipTypeChartRef.current.handleDownloadExcel();
    }

    const handleDownloadPDF = () => {
        // Call BarChart's handleDownloadPDF method here
        barChartRef.current.handleDownloadPDF();
        licenceSpliteUpRef.current.handleDownloadPDF();
        NoofLicenceFunnelRef.current.handleDownloadPDF();
        customerStatusChartRef.current.handleDownloadPDF();
        relationShipTypeChartRef.current.handleDownloadPDF();
    };
    const handleDownloadWord = () => {
        // Call BarChart's handleDownloadPDF method here
        barChartRef.current.handleDownloadWord();
        licenceSpliteUpRef.current.handleDownloadWord();
        NoofLicenceFunnelRef.current.handleDownloadWord();
        customerStatusChartRef.current.handleDownloadWord();
        relationShipTypeChartRef.current.handleDownloadWord();
    };
    // const handlePrint = () => {
    //     // Call BarChart's handleDownloadPDF method here
    //     // Ensure refs are correctly set before calling print
    //     if (barChartRef.current && licenceSpliteUpRef.current && NoofLicenceFunnelRef.current && customerStatusChartRef.current && relationShipTypeChartRef.current) {
    //         barChartRef.current.handlePrint();
    //         licenceSpliteUpRef.current.handlePrint();
    //         NoofLicenceFunnelRef.current.handlePrint();
    //         customerStatusChartRef.current.handlePrint();
    //         relationShipTypeChartRef.current.handlePrint();
    //     } else {
    //         console.error('One or more refs are not initialized.');
    //     }
    // };

    const handlePrint = async () => {
        let printableContent = '<html><head><title>Print Charts</title></head><body>';

        const refs = [
            barChartRef.current,
            licenceSpliteUpRef.current,
            NoofLicenceFunnelRef.current,
            customerStatusChartRef.current,
            relationShipTypeChartRef.current
        ];

        for (const ref of refs) {
            if (ref && ref.handleDownloadImage) {
                try {
                    const imageSrc = await ref.handleDownloadImage(); // Get image URL
                    if (imageSrc) {
                        printableContent += `<img src="${imageSrc}" style="width:100%; margin-bottom: 20px;" />`;
                    }
                } catch (error) {
                    console.error(`Error getting image from chart:`, error);
                }
            } else {
                console.error('One or more refs are not initialized or missing handleDownloadImage.');
            }
        }

        printableContent += '</body></html>';

        const printWindow = window.open('', '_blank');
        if (printWindow) {
            printWindow.document.open();
            printWindow.document.write(printableContent);
            printWindow.document.close();
            setTimeout(() => {
                printWindow.print();
                printWindow.close();
            }, 500);
        } else {
            console.error("Popup blocked. Please allow popups for this site.");
        }
    };

    // const handlePrint = async () => {
    //     if (!barChartRef.current || !licenceSpliteUpRef.current || !NoofLicenceFunnelRef.current) {
    //         console.error("One or more refs are not initialized.");
    //         return;
    //     }

    //     const printSteps = [
    //         () => barChartRef.current.handlePrint(),
    //         () => licenceSpliteUpRef.current.handlePrint(),
    //         () => NoofLicenceFunnelRef.current.handlePrint(),
    //     ];

    //     let currentStep = 0;

    //     const proceedToNextPrint = () => {
    //         if (currentStep < printSteps.length) {
    //             setTimeout(() => {
    //                 printSteps[currentStep++]();
    //             }, 2000); // Delay of 2 seconds to allow printing before opening next
    //         }
    //     };

    //     // Start the first print
    //     proceedToNextPrint();

    //     // Listen for when print is completed and move to the next
    //     window.onafterprint = () => {
    //         proceedToNextPrint();
    //     };
    // };

    const handleDownloadImage = () => {
        // Call BarChart's handleDownloadPDF method here
        barChartRef.current.handleDownloadImage();
        licenceSpliteUpRef.current.handleDownloadImage();
        NoofLicenceFunnelRef.current.handleDownloadImage();
        customerStatusChartRef.current.handleDownloadImage();
        relationShipTypeChartRef.current.handleDownloadImage();
    };

    return (
        <div className='dashboard-container'>
            <Main>
                <div className='components-download-container'>
                    <Download moduleName="Customer Dashboard"
                        showBackButton={true}
                        showDashboardLibraryButton={true}
                        showSaveCustomViewButton={true}
                        showAnalyticsButton={false}
                        showDownloadDropdown={true}
                        onClick={handleDashboardLibraryClick}
                        onBackClick={handleBack}
                        // onImageClick={handleDownloadImage}
                        onExcelDownloadClick={handleDownloadExcel}
                        onPdfDownloadClick={handleDownloadPDF}
                        onWordDownloadClick={handleDownloadWord}
                        onPrintClick={handlePrint}
                        onImageClick={handleDownloadImage}
                    />
                </div>
                <div>
                    <Row className='dashboard-cards-container'>
                        <Col md={3} className='p-0 pe-3 dashboard-cards-cols'>
                            <div className='dashboard-cards'
                            // onClick={handleNavigation}
                            >
                                <div className='dashboard-cards-counts'>
                                    <p>Total Customer</p>
                                    <b>{loading ? <Skeleton width={100} /> : getCustomerDashboardCardData?.TotalCompanies}</b>
                                </div>
                                <div className='dashboard-cards-image'>
                                    <img src={totalCustomer} alt="" />
                                </div>
                            </div>
                        </Col>
                        <Col md={3} className='p-0 pe-3 dashboard-cards-cols'>
                            <div className='dashboard-cards'
                            // onClick={handleNavigation}
                            >
                                <div className='dashboard-cards-counts'>
                                    <p>Active / InActive</p>
                                    {/* <b>{getCustomerDashboardCardData?.ActiveCompanies}/{getCustomerDashboardCardData?.InActiveCompanies}</b> */}
                                    <b>{loading ? <Skeleton width={100} /> : `${getCustomerDashboardCardData?.ActiveCompanies}/${getCustomerDashboardCardData?.InActiveCompanies}`}</b>
                                </div>
                                <div className='dashboard-cards-image' style={{ backgroundColor: "rgba(255, 94, 94, 0.2)" }}>
                                    <img src={activeInactive} alt="" />
                                </div>
                            </div>
                        </Col>
                        <Col md={3} className='p-0 pe-3 dashboard-cards-cols'>
                            <div className='dashboard-cards'
                            // onClick={handleNavigation}
                            >
                                <div className='dashboard-cards-counts'>
                                    <p>Customer Under Validity</p>
                                    <b>{loading ? <Skeleton width={100} /> : getCustomerDashboardCardData?.ValidCompanies}</b>
                                </div>
                                <div className='dashboard-cards-image' style={{ backgroundColor: "rgba(255, 159, 0, 0.2)" }}>
                                    <img src={customerUnderValidity} alt="" />
                                </div>
                            </div>
                        </Col>

                        {/* <Col md={3} className="p-0 dashboard-cards-cols">
                        <div className="dashboard-cards">
                            <div className="dashboard-cards-counts">
                                <p>Customer License Expiration</p>
                                <b>{getCustomerDashboardCardData?.LicenseExpiringCompanies}</b>
                                <p className="dashboard-expiring-text">Expiring in 30 days</p>
                                <div className="progress dashboard-progress">
                                    <div
                                        className="dashboard-progress-bar"
                                        role="progressbar"
                                        style={{ width: "30%", backgroundColor: "#343A40" }}
                                        aria-valuenow="30"
                                        aria-valuemin="0"
                                        aria-valuemax="100"
                                    ></div>
                                </div>
                            </div>
                            <div className="dashboard-cards-image" style={{ backgroundColor: "rgba(52, 58, 64, 0.2)" }}>
                                <img src={customerLicenseExperation} alt="License Expiration Icon" />
                            </div>
                        </div>
                    </Col> */}

                        <Col md={3} className="p-0 dashboard-cards-cols">
                            <div className="dashboard-cards">
                                <div className="dashboard-cards-counts">
                                    <p>Customer License Expiration</p>
                                    <b>{loading ? <Skeleton width={100} /> : getCustomerDashboardCardData?.LicenseExpiringCompanies}</b>
                                    <p className="dashboard-expiring-text">Expiring in {daysRemaining} days</p>
                                    {/* Range Slider for changing days */}
                                    <div className="dashboard-progress-bar">
                                        <input
                                            type="range"
                                            min="0"
                                            max="30"
                                            value={daysRemaining}
                                            onChange={handleSliderChange}
                                        // style={{ width: "100%", accentColor: "rgb(52, 58, 64)", height: "0.2rem" }} // Make the slider full width
                                        />
                                    </div>
                                </div>
                                <div
                                    className="dashboard-cards-image"
                                    style={{ backgroundColor: "rgba(52, 58, 64, 0.2)" }}
                                >
                                    <img
                                        src={customerLicenseExperation}
                                        alt="License Expiration Icon"
                                    />
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Row className='dashboard-charts'>
                        <Col xs={12} sm={12} md={6} lg={6} className='dashboard-charts-div p-0'>
                            <div className='charts-container'>
                                <BarChart
                                    moduleName="Customer Details"
                                    showTypeNameMonth={false}
                                    showYear={true}
                                    label="Customer Details"
                                    // handleDownloadPDF={handleDownloadPDF}
                                    ref={barChartRef}
                                />
                            </div>
                        </Col>
                        <Col xs={12} sm={12} md={3} lg={3} className='dashboard-charts-div p-0 '>
                            <div className='charts-container'>
                                <RelationshipTypeChart
                                    moduleName="Relationship Type"
                                    labels={Rlabels}
                                    colors={Rcolors}
                                    data={Rdata}
                                    showYear={true}
                                    showCompany={true}
                                    ref={relationShipTypeChartRef}
                                />
                            </div>
                        </Col>
                        <Col xs={12} sm={12} md={3} lg={3} className='dashboard-charts-div p-0 pe-4'>
                            <div style={{ height: "100%" }}>
                                <FunnelChart
                                    moduleName="No of Licence"
                                    colors={funnelColors}
                                    labels={funnelLabels}
                                    data={funnelData}
                                    ref={NoofLicenceFunnelRef}
                                />
                            </div>
                        </Col>
                    </Row>
                    <Row className='dashboard-charts pt-4 pb-4'>
                        <Col md={6} className='dashboard-charts-div p-0'>
                            <div className='charts-container'>
                                <LicenceSpliteUpChart ref={licenceSpliteUpRef} />
                            </div>
                        </Col>
                        <Col md={3} className='dashboard-charts-div p-0'>
                            <div className='charts-container'>
                                <CustomerStatusChart
                                    labels={labels}
                                    colors={colors}
                                    data={data}
                                    ref={customerStatusChartRef}
                                />
                            </div>
                        </Col>
                        <Col md={3} className='dashboard-charts-div p-0 pe-4'>
                            <AssignedModules />
                        </Col>
                    </Row>
                </div>
            </Main>
        </div>
    )
}

export default DashBoard

